<template>
  <div class="px-0 px-sm-4 py-4 d-flex w-100">
    <v-card
      :loading="loading"
      class="rounded-0 w-100"
      color="grey lighten-3"
      elevation="0"
    >
      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2" cols="12" md="8">
          <v-card
            v-if="info && Object.keys(info).length > 0"
            class="rounded-lg d-flex align-center fill-height"
            elevation="0"
          >
            <div class="pa-2">
              <v-img
                :src="getImage"
                class="mx-auto mx-sm-0"
                contain
                max-width="165"
              >
                <template v-slot:placeholder>
                  <v-skeleton-loader
                    class="rounded"
                    max-width="100%"
                    type="card"
                  />
                </template>
              </v-img>
            </div>

            <div class="d-flex px-4 pb-4 pa-md-0">
              <v-card-text class="pa-0 d-inline-block">
                <v-card-subtitle class="pa-0 ms-10">
                  {{ info.type | qrType("name") }}
                </v-card-subtitle>
                <div class="font-size-h4 font-weight-bold">
                  <v-badge
                      v-if="$options.filters.qrType(info.type, 'pro')"
                      color="transparent"
                      overlap
                      offset-x="23"
                      offset-y="10"
                    >
                      <template #badge>
                        <v-icon color="grey darken-3" size="13" class="glow-crown">mdi-crown</v-icon>
                      </template>
                      <v-icon class="me-2 icon-list-type" color="grey darken-3" size="32">mdi-{{ info.type | qrType("icon") }}</v-icon>
                    </v-badge>
                    <v-icon v-else class="me-2 icon-list-type" color="grey darken-3" size="32">mdi-{{ info.type | qrType("icon") }}</v-icon>
                  <div
                    v-if="!editVisitName"
                    class="d-inline-flex align-center"
                    style="height: 40px"
                  >
                    {{ info.title }}
                    <v-btn icon small @click="editVisitName = true">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                  <v-card
                    v-else
                    v-click-outside="onCloseField"
                    class="d-inline-block"
                    elevation="0"
                    max-width="250"
                  >
                    <div class="rowinfo">
                      <v-text-field
                        v-model="editedName"
                        :disabled="nameLoading"
                        :error-messages="errorMessage"
                        :hide-details="!errorMessage"
                        :loading="nameLoading"
                        append-icon="check"
                        autofocus
                        clearable
                        class="contentinfo"
                        dense
                        outlined
                        @click:append="updateVisitName"
                        @click:clear="onCloseField"
                        @keydown.enter="updateVisitName"
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-editedName`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="ویرایش"
                      />
                    </div>
                  </v-card>
                </div>

                <div class="pt-2 desc-text w-fit-content cursor-pointer">
                  <v-icon class="ms-1 me-3" size="22">mdi-link-variant</v-icon>

                  <v-tooltip v-model="showTooltip" color="green darken-1" top>
                    <template v-slot:activator="{ on }">
                      <a
                        :href="isSpecialUser ? '' : qrLink"
                        :style="
                          isSpecialUser
                            ? 'user-select: none; pointer-events: none'
                            : ''
                        "
                        target="_blank"
                        >{{ displayLink }}</a
                      >
                    </template>

                    <span>کپی شد</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :disabled="isSpecialUser"
                        icon
                        small
                        v-bind="attrs"
                        @click="copyUrl"
                        v-on="on"
                      >
                        <v-icon small>mdi-content-copy</v-icon>
                      </v-btn>
                    </template>

                    <span>کپی</span>
                  </v-tooltip>
                </div>

                <v-tooltip left>
                  <template v-slot:activator="{ on, attr }">
                    <div
                      class="pt-2 desc-text w-fit-content"
                      v-bind="attr"
                      v-on="on"
                    >
                      <v-icon class="ms-1 me-3" size="22"
                        >mdi-clock-outline</v-icon
                      >
                      {{ dateDiffNow(info.created_at) }}
                    </div>
                  </template>

                  <span style="font-size: 0.8em">{{
                    dateString(info.created_at)
                  }}</span>
                </v-tooltip>
              </v-card-text>
            </div>

            <v-spacer />
            <div class="fill-height d-flex flex-column">
              <v-spacer />
              <v-card-text class="text-left font-size-h6">
                <span class="pa-2 grey--text">کل بازدید:</span>
                <span class="green--text font-size-h1 font-weight-bolder">
                  {{ staticClicks.all || 0 | persianNum }}
                </span>
                <br />
                <span class="py-2 d-inline-block">
                  بازدید یکتا:
                  {{ (staticClicks.unique || 0) | persianNum }}
                </span>
              </v-card-text>
              <v-spacer />

              <v-card-actions class="justify-end d-flex flex-wrap">
                <!-- <custom-date-picker
                  v-model="dateRange.startAt"
                  :max="computedMaxDate"
                  :min="!!info.created_at ? info.created_at.split(' ')[0] : ''"
                  input-class="start-date"
                  nullable
                >
                  <template v-slot:default="{ inputClass }">
                    <v-btn :class="inputClass" class="ml-2" text>
                      <span class="green--text ml-1">شروع: </span>
                      {{
                        !!dateRange.startAt ? datetime(dateRange.startAt) : "--"
                      }}
                      <v-icon color="green" right>mdi-calendar-range</v-icon>
                    </v-btn>
                  </template>
                </custom-date-picker> -->

                <v-btn
                  v-if="!!dateRange.startAt"
                  class="ml-1"
                  color="red"
                  icon
                  small
                  @click.stop="dateRange.startAt = ''"
                >
                  <v-icon> mdi-close </v-icon>
                </v-btn>

                <!-- <custom-date-picker
                  v-model="dateRange.endAt"
                  :max="nowDateTimeString('-', 'date')"
                  :min="computedMinDate"
                  input-class="end-date"
                  nullable
                >
                  <template v-slot:default="{ inputClass }">
                    <v-btn :class="inputClass" class="ml-2" text>
                      <span class="green--text ml-1">پایان: </span>
                      {{ !!dateRange.endAt ? datetime(dateRange.endAt) : "--" }}
                      <v-icon color="green" right>mdi-calendar-range</v-icon>
                    </v-btn>
                  </template>
                </custom-date-picker> -->

                <v-btn
                  v-if="!!dateRange.endAt"
                  class="ml-1"
                  color="red"
                  icon
                  small
                  @click.stop="dateRange.endAt = ''"
                >
                  <v-icon> mdi-close </v-icon>
                </v-btn>

                <v-menu min-width="100" offset-y open-on-hover>
                  <template v-slot:activator="{ on, attrs }">
                    <!-- <v-btn text v-bind="attrs" v-on="on">
                      <span class="green--text ml-1">نمایش آمار:</span>
                      {{
                        !!computedTypes.length
                          ? computedTypes.find(
                              (t) => t.value === computedSelectedType
                            ).text
                          : ""
                      }}
                      <v-icon color="green" right>mdi-selection-search</v-icon>
                    </v-btn> -->
                  </template>

                  <v-list>
                    <v-list-item-group v-model="computedSelectedType">
                      <v-list-item
                        v-for="(item, index) in computedTypes"
                        :key="index"
                      >
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>

                <v-menu min-width="100" offset-y open-on-hover>
                  <template v-slot:activator="{ on, attrs }">
                    <!-- <v-btn text v-bind="attrs" v-on="on">
                      <span class="green--text ml-1">فیلتر:</span>
                      {{
                        !!computedDateType.length
                          ? computedDateType.find(
                              (d) => d.value === computedFilter
                            ).text
                          : ""
                      }}
                      <v-icon color="green" right>mdi-chart-areaspline</v-icon>
                    </v-btn> -->
                  </template>

                  <v-list>
                    <v-list-item-group v-model="computedFilter">
                      <v-list-item
                        v-for="(item, index) in computedDateType"
                        :key="index"
                      >
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </v-card-actions>
            </div>
          </v-card>

          <v-card
            v-else
            class="pa-4 d-flex align-center rounded-lg"
            elevation="0"
            height="100%"
          >
            <v-skeleton-loader height="130" type="image" width="130" />
          </v-card>
        </v-col>

        <v-col class="pa-2" cols="12" md="4">
          <v-card
            class="rounded-lg d-flex flex-column justify-space-between"
            elevation="0"
            height="100%"
            width="100%"
            :loading="loading"
          >
            <v-card-title class="align-end">
              <div
                v-if="!loading"
                :class="getExpireAt | untilExpire | expireColor"
                class="expire-option"
              >
                {{ getExpireAt | untilExpire | persianNum }}
                <br />
                <span class="black--text">{{
                  getExpireAt | untilExpire | typeText(false)
                }}</span>
              </div>
              <v-spacer />
              <!-- <v-tooltip v-if="!!info && !!Object.keys(info).length" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :href="
                      findEditPage(info.domain.name, info.identifier, info.type)
                    "
                    class="rounded-lg"
                    color="black"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>

                <span>ویرایش</span>
              </v-tooltip> -->
            </v-card-title>

            <v-card-actions class="justify-end">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    @click="
                      goto(`qr/design/${domainName}${!!qrId ? qrId : ''}`)
                    "
                    v-on="on"
                  >
                    <v-icon small>mdi-palette</v-icon>
                  </v-btn>
                </template>

                <span>دیزاین</span>
              </v-tooltip>

              <v-tooltip v-if="info.status === 'active'" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    @click="showPause('deactivate')"
                    v-on="on"
                  >
                    <v-icon small>mdi-pause</v-icon>
                  </v-btn>
                </template>

                <span>متوقف کردن</span>
              </v-tooltip>

              <v-tooltip v-else top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    @click="downloadQr"
                    v-on="on"
                  >
                    <v-icon small>mdi-download</v-icon>
                  </v-btn>
                </template>

                <span>دانلود</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="
                      info.permissions
                        ? info.permissions.edit_link
                          ? false
                          : true
                        : false
                    "
                    :href="
                      findEditPage(
                        info?.domain?.name,
                        info?.identifier,
                        info?.type,
                        info?.qrId,
                      )
                    "
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>

                <span>ویرایش</span>
              </v-tooltip>

              <!-- <v-tooltip color="red darken-1" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-hover v-slot="{ hover }">
                    <v-btn
                      :color="hover ? 'red darken-2' : ''"
                      icon
                      small
                      v-bind="attrs"
                      @click="showDestroy"
                      v-on="on"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </v-hover>
                </template>

                <span>حذف</span>
              </v-tooltip> -->
            </v-card-actions>

            <v-card-actions
              :class="getExpireAt | untilExpire | expireColor"
              class="download-wrapper"
            >
              <v-progress-circular
                v-if="loading && !(info && Object.keys(info).length > 0)"
                class="my-2 mx-auto"
                color="white"
                indeterminate
                size="20"
                width="3"
              />

              <v-btn
                v-else-if="info.status === 'active'"
                block
                class="font-size-h6"
                dark
                large
                text
                @click="downloadQr"
              >
                دانلود
                <v-spacer />
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>

              <v-btn
                v-else
                block
                class="font-size-h6 rounded-lg"
                dark
                large
                outlined
                @click="showPause('active')"
              >
                فعال کردن
                <v-spacer />
                <v-icon>mdi-reload</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <div class="w-100" v-if="!admin && !loading">
          <v-col class="pa-2" cols="12">
            <commercialTags
              :admin="admin"
              :qrland="info.id"
              v-model="selectShop"
            />
          </v-col>
          <v-col
            v-if="selectShop.qr_id || selectShop.id"
            class="pa-2 w-100"
            cols="12"
          >
            <commercialList
              v-model="selectShop"
              :selectShop="selectShop"
              :qrland="info.id"
              :admin="admin"
            />
          </v-col>
        </div>
        <!-- admin -->
        <div class="w-100" v-if="admin && !loading">
          <div style="display: none">
            <!-- <commercialTags
              :admin="admin"
              :qrland="info.id"
              v-model="selectShop"
            /> -->
          </div>
          <v-col cols="12">
            <!-- <commercial-admin
              :admin="admin"
              :qrland="info.id"
              v-model="selectShop"
            />  -->
            <partnership-admin
              :admin="admin"
              :qrland="info.id"
              v-model="selectShop"
            />
          </v-col>
        </div>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import commercialTags from "./commercialTags.vue";
import commercialList from "./commercialList.vue";
import commercialAdmin from "./components/commercialAdmin/commercialAdmin.vue";
import partnershipAdmin from "./components/commercialAdmin/partnershipAdmin.vue";
export default {
  name: "partnership",
  components: {
    commercialTags,
    commercialList,
    commercialAdmin,
    partnershipAdmin,
  },

  data: () => ({
    cons: { title: "دانلود کیوآر" },
    dateRange: {
      startAt: "",
      endAt: "",
    },
    dateTypeModel: "d",
    editVisitName: false,
    editedName: "",
    errorMessage: null,
    filterModel: "w",
    info: {},
    itemMenu: [],
    loadChart: false,
    loading: false,
    nameLoading: false,
    optionMenu: false,
    selectedType: "all",
    showDialog: false,
    showTooltip: false,
    staticClicks: {},
    totalSeen: 0,
    uniqueSeen: 0,
    selectShop: {},
    selectShopAdmin: [],
    admin: false,
  }),

  mounted() {
    this.itemMenu = [
      {
        value: "download",
        text: "دانلود CSV",
        icon: "download",
        handler: null,
      },
      {
        value: "reset",
        text: "حذف آمار",
        icon: "reload",
        handler: this.resetStatics,
      },
    ];

    this.fetch();
  },

  computed: {
    isSpecialUser() {
      return this.info?.user_id === 4;
    },
    qrLink() {
      let link = this.info.domain?.name || "";
      if (!link.startsWith("http")) {
        link = "https://" + link;
      }

      if (!!this.info.identifier) return link + this.info.identifier;
      return link;
    },
    displayLink() {
      let rgx = /^(http|https):\/\//gm;
      return this.qrLink.replace(rgx, "");
    },
    innerWidth() {
      return window.innerWidth;
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    getExpireAt() {
      return this.info.prices &&
        this.info.prices.length > 0 &&
        this.info.prices[0].expire_at
        ? this.info.prices[0].expire_at
        : this.info.expired_at;
    },
    getImage() {
      return `${this.$qrUrl}/qr/${this.info.image}`;
    },
    computedDateType: {
      get() {
        return this.$refs.statics?.filters || [];
      },
    },
    computedFilter: {
      get() {
        return this.dateTypeModel;
      },
      set(val) {
        this.dateTypeModel = this.computedDateType[val].value;
      },
    },
    computedTypes() {
      return this.$refs.statics?.type || [];
    },
    computedSelectedType: {
      get() {
        return this.selectedType;
      },
      set(val) {
        this.selectedType = this.computedTypes[val].value;
      },
    },
    computedMaxDate() {
      return !!this.dateRange.endAt
        ? this.dateRange.endAt.split(" ")
        : this.nowDateTimeString("-", "date");
    },
    computedMinDate() {
      return !!this.dateRange.startAt
        ? this.dateRange.startAt.split(" ")[0]
        : !!this.info.created_at
        ? this.info.created_at.split(" ")[0]
        : "";
    },
  },

  created() {},

  watch: {
    info: {
      deep: true,
      handler(val) {
        if (val.type.toLowerCase() === "commericial") {
          this.admin = true;
        } else {
          this.admin = false;
        }
      },
    },
  },

  methods: {
    fetch() {
      this.loading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`,
        )
        .then(({ data }) => {
          this.info = data.data;
          this.editedName = data.data.visitName;
          this.$nextTick(() => {
            this.getVisits();
            // this.getStatics()
          });
        })
        .finally(() => (this.loading = false));
    },
    copyUrl() {
      if (this.info.domain) {
        navigator.clipboard.writeText(this.qrLink);
        this.showTooltip = true;
      }
    },
    onCloseField() {
      this.errorMessage = null;
      this.editVisitName = false;
    },
    updateVisitName() {
      if (!this.editedName || this.editedName.length <= 0) {
        this.errorMessage = "نام کارت ویزیت را به درستی وارد نمایید!";
        return;
      }

      this.nameLoading = true;
      this.$api
        .put("/v1/testQr/update", {
          qr_id: this.info.qrId,
          title: this.editedName,
        })
        .then(({ data }) => {
          this.onCloseField();
          this.info.title = this.editedName;
        })
        .finally(() => (this.loading = false));
    },
    downloadQr() {
      this.showDialog = true;
      // return;

      let src = this.info[this.info.format];
      const data = JSON.stringify(src);
      const link = document.createElement("a");
      let type = this.info.format;

      link.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(data),
      );
      link.setAttribute(
        "download",
        this.info.visitName + `.${type}` || "data.json",
      );
      link.style.display = "none";

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    },
    async showDestroy() {
      if (await this.$modal.yesNo("آیا از حذف کیوآر مطمئن هستید؟")) {
        this.destroy();
      }
    },
    findEditPage(name, id, type, qrid) {
      const types = {
        visitcard: `#/qr/edit/${name}${!!id ? id : ""}`,
        visitcardpro: `#/qr/editpro/${name}${!!id ? id : ""}`,
        business: `#/qr/editBpage/${name}${!!id ? id : ""}`,
        socialmedia: `#/qr/editSocial/${name}${!!id ? id : ""}`,
        commericial: `#/qr/editCpage/${name}${!!id ? id : ""}`,
        qrlist: `#/qr/qrlist/${!!id ? id : ""}`,
        goldlabel: `#/qr/goldlabel/${name}${!!id ? id : ""}`,
        labelproduct: `#/qr/labelproduct/${name}${!!id ? id : ""}`,
        voicegallery: `#/qr/editVoice/${name}${!!id ? id : ""}`,
        voicegallerypro: `#/qr/editVoicePro/${name}${!!id ? id : ""}`,
        consultationqr: `#/qr/consultationQrEdit/${name}${!!id ? id : ""}`,
        qrlink: `#/qr/link/${!!qrid ? qrid : ""}`,
        clickyarseo: `#/qr/linkpro/${!!qrid ? qrid : ""}`,
        videogallery: `#/qr/editVideo/${name}${!!id ? id : ""}`,
        photogallery: `#/qr/editPhoto/${name}${!!id ? id : ""}`,
        singleproduct: `#/qr/product/${name}${!!id ? id : ""}`,
        menu: `#/qr/editMenu/${name}${!!id ? id : ""}`,
        bshop: `#/qr/editBShop/${name}${!!id ? id : ""}`,
        application: `#/qr/editApplication/${name}${!!id ? id : ""}`,
        cshop: `#/qr/editCShop/${name}${!!id ? id : ""}`,
        appointment: `#/qr/editAppointment/${name}${!!id ? id : ""}`,
        insurance: `#/qr/insurance/${name}${!!id ? id : ""}`,
        wheel: `#/qr/luck-wheel/${name}${!!id ? id : ""}`,
        multicard: `#/qr/multicard/${name}${!!id ? id : ""}`,
        feedbackgallery: `#/qr/editFeedback/${name}${!!id ? id : ""}`,
        productpro: `#/qr/productPro/${name}${!!id ? id : ""}`,
        pdfgallery: `#/qr/editPdf/${name}${!!id ? id : ""}`,
        catalog: `#/qr/editcatalog/${name}${!!id ? id : ""}`,
        gift:`#/qr/editgift/${name}${!!id ? id : ""}`,
        text:`#/qr/editText/${name}${!!id ? id : ""}`,
        qrbale:`#/qr/editBale/${name}${!!id ? id : ""}`,
        qrrobika:`#/qr/editRobika/${name}${!!id ? id : ""}`,
        qreitaa:`#/qr/editEitaa/${name}${!!id ? id : ""}`,
        bankcard:`#/qr/bankcard/${name}${!!id ? id : ""}`,
        pricelabel: `#/qr/labelprice/${name}${!!id ? id : ""}`,
        attendanceqr: `#/qr/editattendance/${name}${!!id ? id : ""}`,     
             };

      return types[type?.toLowerCase()];
      // this.goto(types[type]);
    },
    getVisits() {
      this.loading = true;
      let params = {
        domain: this.domainName + "/",
        identifier: this.qrId || "",
      };

      if (!!this.dateRange.startAt) params.start_at = this.dateRange.startAt;
      if (!!this.dateRange.endAt) params.end_at = this.dateRange.endAt;

      this.$api
        .get("/v1/testQr/statistics-click", {
          params: params,
        })
        .then(({ data }) => {
          this.staticClicks = data.data;
        })
        .catch(({ response }) => console.log("error in get clicks: ", response))
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.expire-option {
  width: fit-content;
  white-space: nowrap;
  padding: 2px 8px;
  color: forestgreen;
}

.download-wrapper {
  background: linear-gradient(to right bottom, #02c182, #02c182, #08f1a1);
}

.expire-option.in-month {
  color: var(--v-warning-base);
}

.download-wrapper.in-month {
  background: var(--v-warning-base);
}

.expire-option.in-days {
  color: darkorange;
}

.download-wrapper.in-days {
  background: darkorange;
}

.expire-option.in-expire {
  color: var(--v-third-base);
}

.download-wrapper.in-expire {
  background: var(--v-third-base);
}

.desc-text,
.desc-text >>> a,
.desc-text >>> .v-icon:not(:hover) {
  color: #c2c2c2;
}

.chart-wrapper {
  /*background: linear-gradient(to right, #1D9191, #5FBCBC);*/
  background: linear-gradient(to right, #02c182, #08f1a1);
}
</style>

<style>
.apex-custom-label tspan,
.apex-custom-label title {
  font-family: "Vazir", serif !important;
}
</style>
